
var sprite = require("/home/jenkins/agent/workspace/rod-authoring-homepage-ui_master/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 16\" id=\"search_16\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0z M6,11c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5\n\t\tS8.8,11,6,11z\" fill=\"#949494\"> </path> <rect fill=\"#949494\" height=\"5.7\" transform=\"matrix(-0.7071 0.7071 -0.7071 -0.7071 31.4698 13.0355)\" width=\"2\" x=\"12\" y=\"10.2\"> </rect> </g> </symbol>";
module.exports = sprite.add(image, "search_16");


//////////////////
// WEBPACK FOOTER
// ./app/common/icons/search_16.svg
// module id = 58
// module chunks = 0